import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';
import { SquareArrowRight } from 'lucide-react';

const AdvisoryBoardCarousel = ({ members }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const swiperInstance = swiperRef.current.swiper;
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, []);


  return (
    <div className="w-full py-12">
      <div className="max-w-7xl mx-auto md:px-6">
        {/* Heading */}
        <div className="text-center md:text-center mb-10 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-[48px] leading-tight font-bold text-gray-900 tracking-tight">
            Advisory Board
          </h2>
          <p className="mt-4 text-gray-500 text-base md:text-lg lg:text-xl leading-relaxed">
            Our success stems from a passionate, skilled, and innovative team,
            each member contributing unique talents and dedication in a thriving
            collaborative environment.
          </p>
        </div>

        {/* Swiper Carousel with Navigation */}
        <div className="relative advisory-carousel">
          <Swiper
            ref={swiperRef}
            modules={[Navigation, Pagination, Autoplay]}
            loop={true}
            slidesPerView={1}
            spaceBetween={30}
            breakpoints={{
              768: { slidesPerView: 2, spaceBetween: 30 },
              1024: { slidesPerView: 3, spaceBetween: 30 },
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            autoplay={{
              delay: 4000,
            }}
            className="relative"
          >
            {members.map((member, index) => (
              <SwiperSlide key={index}>
                <div className="duration-300 flex flex-col items-center">
                  <div className="overflow-hidden w-56 h-56 rounded-full mb-4 md:mb-6">
                    <img
                      src={member.img}
                      alt={member.name}
                      className=" w-full h-full object-cover rounded-full"
                    />
                  </div>
                  <div className="text-center">
                    <div className="flex justify-center md:justify-between items-center">
                      <div className="text-center md:text-start">
                        <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-1">{member.name}</h3>
                        <p className="text-sm text-gray-600">{member.position}</p>
                      </div>
                      <div className="text-end md:ml-8 hidden md:block">
                        <a
                          href={member.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className=""
                        >
                          <img
                            src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
                            alt="LinkedIn"
                            className="w-6 h-6"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="md:hidden flex justify-center mt-2"> {/* Mobile LinkedIn icon */}
                      <a
                        href={member.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
                          alt="LinkedIn"
                          className="w-6 h-6"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Arrows */}
          {/* <div
            ref={prevRef}
            className="absolute left-0 top-1/2 z-10 -ml-12 flex h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center"
            >
            <SquareArrowLeft size={30} />
          </div> */}
          <div
            ref={nextRef}
            className="absolute md:flex hidden right-0 top-1/2 z-10 -mr-12 flex h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center"
          >
            <SquareArrowRight size={30} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvisoryBoardCarousel;